import React from 'react';
import { View } from '@react-pdf/renderer';
import { styles } from '../styles';
import { CustomerBox } from './CustomerBox';
import { ContactBox } from './ContactBox';
import { CustomerServiceBox } from './CustomerServiceBox';
import { DeliveryAddressBox } from './DeliveryAddressBox';
import { OrderSummaryBox } from './OrderSummaryBox';
import { OrderNotes } from './OrderNotes';

export const OrderInfo = ({ order }) => (
  <View style={styles.orderInfo}>
    <View style={styles.row}>
      <View style={styles.columna}>
        <CustomerBox customer={order.customer} />
        <ContactBox contact={order.contact} />
        <CustomerServiceBox cs={order.customerService} />
        <OrderNotes notes={order.notes} />
      </View>
      <View style={styles.columnb}>
        <DeliveryAddressBox address={order.deliveryAddress} />
        <OrderSummaryBox summary={order.summary} />
      </View>
    </View>
  </View>
);
